import type { MouseEvent, ReactNode } from 'react'
import { navigateHome } from '@utils/route'

export interface BrandHomeLinkProps {
  /** ラッパ <a> の className (既存 CSS に合わせる: auth-brand / brand など)。 */
  className: string
  /** スクリーンリーダ向けラベル。 */
  ariaLabel: string
  children: ReactNode
}

/**
 * OoKey ロゴを包む「トップページへ戻る」リンク。クリックで root `/` (landing) に戻す。
 *
 * 通常クリックは preventDefault して same-document で hash を空にする
 * (`navigateHome`)。full reload しないので、ログイン中 (in-memory session) でも
 * セッションを失わない。修飾キー (cmd/ctrl/shift/alt) クリックは既定動作を通し、
 * `/` を新規タブで開けるようにする。
 */
export const BrandHomeLink = ({
  className,
  ariaLabel,
  children,
}: BrandHomeLinkProps): JSX.Element => {
  const onClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    navigateHome()
  }

  return (
    <a className={className} href="/" aria-label={ariaLabel} onClick={onClick}>
      {children}
    </a>
  )
}
